export const decimalMask = (value?: string | number) => {
  if (value === undefined || value === null || value === '') return ''

  let isNegative = false

  if (typeof value === 'number') {
    isNegative = value < 0
    value = Math.abs(value).toFixed(2)
  }

  if (typeof value === 'string') {
    const trimmed = value.trim()

    if (trimmed.startsWith('-') || trimmed.endsWith('-')) {
      isNegative = true
    }

    value = value.replace(/\D/g, '')
  }

  if (!value) return ''

  if (value.length > 2) {
    value = value.replace(/^0+/, '')
  }

  value = value.padStart(3, '0')

  const absoluteNumber = Number(value) / 100
  const signedNumber = isNegative ? -absoluteNumber : absoluteNumber

  return new Intl.NumberFormat('pt-BR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(signedNumber)
}
